import {
  ADD_BOOK,
  DELETE_BOOK,
  EDIT_MODE,
  LOADED,
  UPDATE_BOOK,
} from "./actionTypes";
import initialState from "./initialState";

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOADED:
      return {
        ...state,
        books: [...action.payload],
      };

    case ADD_BOOK:
      return {
        ...state,
        books: [...state.books, { ...action.payload }],
      };

    case EDIT_MODE:
      const { bookInfo, status } = action.payload || {};
      return {
        ...state,
        editMode: {
          ...state.editMode,
          bookInfo,
          status,
        },
      };

    case UPDATE_BOOK:
      const { name, author, thumbnail, price, rating, featured } =
        action.payload.updateInfo;
      return {
        ...state,
        books: [...state.books].map((book) => {
          if (book.id === action.payload.bookId) {
            return {
              ...book,
              name,
              author,
              thumbnail,
              price,
              rating,
              featured,
            };
          } else {
            return book;
          }
        }),
      };

    case DELETE_BOOK:
      return {
        ...state,
        books: [...state.books].filter((book) => book.id !== action.payload),
      };

    default:
      return state;
  }
}
